import { configureStore } from '@reduxjs/toolkit';
import { type Reducer } from 'redux';

import { type RootState } from '../services/types';

const createMockUserReducer = (): Reducer<RootState['user']> => {
  const initialState: RootState['user'] = {
    messages: {
      'rules.dashboard.title': 'Rules Dashboard',
      'rules.title': 'Rules Management',
      // add other messages as needed
    },
    isMenuPinned: false,
  };

  return (state = initialState) => state;
};

export default function getMinimalStore(
  customReducers?: Record<string, Reducer>
) {
  return configureStore({
    reducer: {
      user: createMockUserReducer(),
      // add other reducers as needed
      ...(customReducers ?? {}),
    },
  });
}
